import {createContext, useContext} from 'react'

import type {PersistedOption} from '../../api/columns/contracts/single-select'
import type {MemexStatus} from '../../api/memex/contracts'

export type StatusUpdate = {
  body: string
  startDate: Date | null
  status: PersistedOption | null
  targetDate: Date | null
}

type StatusUpdatesContext = {
  statusUpdates: Array<MemexStatus>
  statusOptions: Array<PersistedOption>
  addStatusUpdate: (statusUpdate: StatusUpdate) => void
  isAdding: boolean
  setIsAdding: (isAdding: boolean) => void
}

export const StatusUpdatesContext = createContext<StatusUpdatesContext | null>(null)

export function useStatusUpdates() {
  const context = useContext(StatusUpdatesContext)

  if (!context) {
    throw new Error('useStatusUpdates must be used within a StatusUpdatesContext.Provider.')
  }

  return context
}
